import PortfolioGridPage from './PortfolioGridPage';

export default function HomePage() {
  return (
    <PortfolioGridPage
      contentType="work"
      aspectRatio="aspect-[4/3]"
      showDescription
      emptyLabel="작업물"
    />
  );
}
